<style scoped="scoped" lang="scss">
.work {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 8px 16px;
  gap: 10px;
  margin-left: 50px;
  width: 344px;
  height: 150px;
  background: #f4f4f5;
  border-radius: 4px;
  flex: none;
  order: 5;
  flex-grow: 0;
}
</style>
<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/production/config/page" getKey="rows" :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('shengchanpeizhileixing')">
            <yi_dictionary_select type="PRODUCTION_CONFIG_TYPE" :ids.sync="yt.conditions.type"></yi_dictionary_select>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain="plain">
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="yt.clear(orderBy)">{{ $t('chongzhi') }}</el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <!-- 左侧按钮插槽 -->
      <template #buttonsL>
        <el-button size="mini" v-if="utils.checkPower('web_system_configuration_create')" @click="yt.showEditDialog('xinzeng', null, 'w2', beforeShowEditDialog)" type="primary">
          {{ $t('xinzeng') }}
        </el-button>
      </template>
      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()"></el-button>
      </template>
      <template #shifouqiyong="scope">
        {{ scope.row.status == 1 ? $t('shi') : $t('fou') }}
      </template>

      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1">
            <el-button type="text" v-if="utils.checkPower('web_system_configuration_update')" @click="yt.showEditDialog('bianji', scope.row, 'w2', beforeShowEditDialog)">{{ $t('bianji') }} </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button type="text" :loading="yt.editObj.loading" v-if="utils.checkPower('web_system_configuration_delete')" class="font-color-danger" @click="yt.remove(scope.row, '/web/production/config/delete')">{{ $t('shanchu') }} </el-button>
          </el-col>
        </el-row>
      </template>
    </yi_curd_table>
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <template v-if="yt.editObj.action == 'xinzeng'">
        <div class="dialog-scroller">
          <!--          {{store.state.dictJsonAll['PRODUCTION_CONFIG_TYPE'][yt.editObj.type]}}-->
          <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
            <el-form-item :label="$t('shengchanpeizhileixing')">
              <yi_dictionary_select type="PRODUCTION_CONFIG_TYPE" :ids.sync="yt.editObj.type" @change="dictionaryChange(yt.editObj.type)"></yi_dictionary_select>
            </el-form-item>

            <div v-if="yt.editObj.type === '0'">
              <el-form-item :label="$t('shifouqiyong')" required>
                <el-select v-model="yt.editObj.status" @change="$forceUpdate()">
                  <el-option :label="$t('shi')" :value="1"></el-option>
                  <el-option :label="$t('fou')" :value="0"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('beizhu')">
                <el-input type="textarea" v-model="yt.editObj.remark"></el-input>
              </el-form-item>
              <p style="font-size: 18px;">{{ $t('peizhixinxi') }}</p>
              <el-form-item style="margin-left: -30px;" :label="$t('juese')" label-width="130px" required></el-form-item>
              <el-form-item style="margin-left: 150px;" :label="$t('baogongjiange(xiaoshi)')" label-width="130px" required></el-form-item>
              <el-form-item style="margin-left: 70px;" :label="$t('jiangexiaoguo')" label-width="105px" required></el-form-item>
            </div>
            <div v-else-if="yt.editObj.type === '1'">
              <el-form-item :label="$t('shifouqiyong')" required>
                <el-select v-model="yt.editObj.status" @change="$forceUpdate()">
                  <el-option :label="$t('shi')" :value="1"></el-option>
                  <el-option :label="$t('fou')" :value="0"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('beizhu')">
                <el-input type="textarea" v-model="yt.editObj.remark"></el-input>
              </el-form-item>
              <el-form-item :label="$t('chaochanleixing')" required>
                <el-select v-model="yt.editObj.overType">
                  <el-option :label="$t('bili')" :value="0"></el-option>
                  <el-option :label="$t('shuliang')" :value="1"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('chaochanzhi')" required>
                <el-input type="number" oninput="value=value.replace(/^0|[^0-9]/g, '')" v-model="yt.editObj.overValue" size="mini"></el-input>
              </el-form-item>
              <p class="work">
                <i style="margin-left: -270px;" class="yicon yicon-tips">{{ $t('shilishuoming') }}</i>
                <span>{{ $t('bilishuoming') }}</span>
                <span>{{ $t('shuliangshuoming') }}</span>
              </p>
            </div>
            <div v-else-if="defaultTypeList.indexOf(yt.editObj.type) > -1">
              <el-form-item :label="$t('shifouqiyong')" required>
                <el-select v-model="yt.editObj.status">
                  <el-option :label="$t('shi')" :value="1"></el-option>
                  <el-option :label="$t('fou')" :value="0"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('beizhu')">
                <el-input type="textarea" v-model="yt.editObj.remark"></el-input>
              </el-form-item>
            </div>
            <div v-else-if="yt.editObj.type === '3'">
              <el-form-item :label="$t('shifouqiyong')" required>
                <el-select v-model="yt.editObj.status" @change="$forceUpdate()">
                  <el-option :label="$t('shi')" :value="1"></el-option>
                  <el-option :label="$t('fou')" :value="0"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('beizhu')">
                <el-input type="textarea" v-model="yt.editObj.remark"></el-input>
              </el-form-item>
            </div>
            <div v-else-if="yt.editObj.type === '4'">
              <el-form-item :label="$t('mujuzhuangtai')" required>
                <yi_dictionary_select :max="999" multiple :type="'BASIC_MOULD_STATUS'" :ids.sync="yt.editObj.mouldStatus"></yi_dictionary_select>
              </el-form-item>
              <el-form-item :label="$t('shifouqiyong')" required>
                <el-select v-model="yt.editObj.status" @change="$forceUpdate()">
                  <el-option :label="$t('shi')" :value="1"></el-option>
                  <el-option :label="$t('fou')" :value="0"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('beizhu')">
                <el-input type="textarea" v-model="yt.editObj.remark"></el-input>
              </el-form-item>
            </div>
            <div v-else-if="yt.editObj.type === '79'">
              <el-form-item :label="$t('模具维修验收状态')" required>
                <yi_dictionary_select :max="999" multiple :type="'EQUIPMENT_ACCEPTANCE_STATUS'" :ids.sync="yt.editObj.mouldStatus"></yi_dictionary_select>
              </el-form-item>
              <el-form-item :label="$t('shifouqiyong')" required>
                <el-select v-model="yt.editObj.status" @change="$forceUpdate()">
                  <el-option :label="$t('shi')" :value="1"></el-option>
                  <el-option :label="$t('fou')" :value="0"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('beizhu')">
                <el-input type="textarea" maxlength="400" show-word-limit v-model="yt.editObj.remark"></el-input>
              </el-form-item>
            </div>

            <div v-else-if="yt.editObj.type === '7'">
              <el-form-item :label="$t('shifouqiyong')" required>
                <el-select v-model="yt.editObj.status">
                  <el-option :label="$t('shi')" :value="1"></el-option>
                  <el-option :label="$t('fou')" :value="0"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('beizhu')">
                <el-input type="textarea" v-model="yt.editObj.remark"></el-input>
              </el-form-item>
              <!--工单限制数量，0或者无不限制数量              -->
              <el-form-item :label="$t('gongdanxianzhishuliang')">
                <el-input-number v-model="configJson.limitNum"></el-input-number>
              </el-form-item>
            </div>
            <div v-else-if="yt.editObj.type === '11'">
              <el-form-item :label="$t('gongdanzhuangtai')" required>
                <yi_dictionary_select :max="8" multiple :type="'PRODUCTION_WO_STATUS'" :ids.sync="yt.editObj.woStatus"></yi_dictionary_select>
              </el-form-item>
              <el-form-item :label="$t('shifouqiyong')" required>
                <el-select v-model="yt.editObj.status" @change="$forceUpdate()">
                  <el-option :label="$t('shi')" :value="1"></el-option>
                  <el-option :label="$t('fou')" :value="0"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('beizhu')">
                <el-input type="textarea" v-model="yt.editObj.remark"></el-input>
              </el-form-item>
            </div>

            <div v-else-if="yt.editObj.type === '12'">
              <el-form-item :label="$t('gongdanyouxianji')" required>
                <el-select v-model="yt.editObj.woStartPriority" @change="$forceUpdate()">
                  <el-option :label="$t('gongdanshunxu')" value="0"></el-option>
                  <el-option :label="$t('jihuakaishishijian')" value="1"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('shifouqiyong')" required>
                <el-select v-model="yt.editObj.status" @change="$forceUpdate()">
                  <el-option :label="$t('shi')" :value="1"></el-option>
                  <el-option :label="$t('fou')" :value="0"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('beizhu')">
                <el-input type="textarea" v-model="yt.editObj.remark"></el-input>
              </el-form-item>
            </div>
            <div v-else-if="yt.editObj.type === '13'">
              <el-form-item :label="$t('shifouqiyong')" required>
                <el-select v-model="yt.editObj.status" @change="$forceUpdate()">
                  <el-option :label="$t('shi')" :value="1"></el-option>
                  <el-option :label="$t('fou')" :value="0"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('beizhu')">
                <el-input type="textarea" v-model="yt.editObj.remark"></el-input>
              </el-form-item>
            </div>
            <div v-else-if="yt.editObj.type === '15'">
              <el-form-item :label="$t('shifouqiyong')" required>
                <el-select v-model="yt.editObj.status" @change="$forceUpdate()">
                  <el-option :label="$t('shi')" :value="1"></el-option>
                  <el-option :label="$t('fou')" :value="0"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('zuidazhangshu') + '(1-50)'" required>
                <el-input-number :min="1" :max="50" step-strictly v-model="yt.editObj.overValue"></el-input-number>
              </el-form-item>
              <el-form-item :label="$t('beizhu')">
                <el-input type="textarea" v-model="yt.editObj.remark"></el-input>
              </el-form-item>
            </div>

            <div v-else-if="yt.editObj.type === '22'">
              <el-form-item :label="$t('shifouqiyong')" required>
                <el-select v-model="yt.editObj.status" @change="$forceUpdate()">
                  <el-option :label="$t('shi')" :value="1"></el-option>
                  <el-option :label="$t('fou')" :value="0"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('shebeimingcheng')">
                <el-row>
                  <el-col :span="20">
                    <yi_data_select ref="equipmentSelect" :multiple="true" :type="'equipment'" :ids.sync="yt.editObj.equipmentIds"></yi_data_select>
                  </el-col>
                  <el-col :span="4">
                    <el-button type="text" @click="selectAll()">{{ $t('quanxuan') }}</el-button>
                  </el-col>
                </el-row>
              </el-form-item>

              <el-form-item :label="$t('baogongren')">
                <yi_data_select :type="'customer_user'" :ids.sync="configJson.reportId"></yi_data_select>
              </el-form-item>

              <el-form-item :label="$t('自动计算产量')">
                <el-checkbox v-model="configJson.checked"></el-checkbox>
              </el-form-item>

              <el-form-item :label="$t('beizhu')">
                <el-input type="textarea" v-model="yt.editObj.remark"></el-input>
              </el-form-item>
            </div>

            <div v-else-if="yt.editObj.type === '24'">
              <el-form-item :label="$t('shifouqiyong')" required>
                <el-select v-model="yt.editObj.status" @change="$forceUpdate()">
                  <el-option :label="$t('shi')" :value="1"></el-option>
                  <el-option :label="$t('fou')" :value="0"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('beizhu')">
                <el-input type="textarea" v-model="yt.editObj.remark"></el-input>
              </el-form-item>
            </div>

            <div v-else-if="yt.editObj.type === '25'">
              <el-form-item :label="$t('shifouqiyong')" required>
                <el-select v-model="yt.editObj.status" @change="$forceUpdate()">
                  <el-option :label="$t('shi')" :value="1"></el-option>
                  <el-option :label="$t('fou')" :value="0"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('beizhu')">
                <el-input type="textarea" v-model="yt.editObj.remark"></el-input>
              </el-form-item>
            </div>
            <div v-else-if="yt.editObj.type === '29'">
              <el-form-item :label="$t('tongzhiyonghu')" required>
                <yi_data_select :multiple="true" :type="'customer_user'" :ids.sync="yt.editObj.equipmentIds"></yi_data_select>
              </el-form-item>
              <el-form-item :label="$t('shifouqiyong')" required>
                <el-select v-model="yt.editObj.status" @change="$forceUpdate()">
                  <el-option :label="$t('shi')" :value="1"></el-option>
                  <el-option :label="$t('fou')" :value="0"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('beizhu')">
                <el-input type="textarea" v-model="yt.editObj.remark"></el-input>
              </el-form-item>
            </div>
            <div v-else-if="yt.editObj.type === '31'">
              <el-form-item :label="$t('shifouqiyong')" required>
                <el-select v-model="yt.editObj.status" @change="$forceUpdate()">
                  <el-option :label="$t('shi')" :value="1"></el-option>
                  <el-option :label="$t('fou')" :value="0"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('beizhu')">
                <el-input type="textarea" v-model="yt.editObj.remark"></el-input>
              </el-form-item>
              <div v-if="yt.editObj.status === 1">
                <el-form-item :label="$t('xieyi')">
                  <el-select v-model="configJson.protocol" style="flex: 1;">
                    <el-option v-for="(h, i) in ['http://', 'https://']" :key="i" :label="h" :value="h"> </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item :label="$t('zhuji')">
                  <el-input style="flex: 4;" type="text" placeholder="ip:port" v-model="configJson.host"></el-input>
                </el-form-item>
                <el-form-item label="AppKey">
                  <el-input type="text" v-model="configJson.appKey"></el-input>
                </el-form-item>
                <el-form-item label="AppSecret">
                  <el-input type="text" v-model="configJson.appSecret"></el-input>
                </el-form-item>
                <el-form-item :label="$t('jiekoushangxiawenlujin')">
                  <el-input type="text" v-model="configJson.contextPath" placeholder="/"></el-input>
                </el-form-item>
                <el-form-item :label="$t('jiankongdianweiyibiaoshi')">
                  <div style="display: flex;">
                    <el-input type="text" v-model="configJson.indexCode"></el-input>
                    <el-tooltip :content="$t('duogeyongdouhaogekai')" placement="right" style="margin: auto 5px;">
                      <i class="el-icon-question"></i>
                    </el-tooltip>
                  </div>
                </el-form-item>
              </div>
            </div>
            <div v-else-if="yt.editObj.type === '33'">
              <el-form-item :label="$t('shifouqiyong')" required>
                <el-select v-model="yt.editObj.status" @change="$forceUpdate()">
                  <el-option :label="$t('shi')" :value="1"></el-option>
                  <el-option :label="$t('fou')" :value="0"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('beizhu')">
                <el-input type="textarea" v-model="yt.editObj.remark"></el-input>
              </el-form-item>
              <p style="font-size: 16px; margin: 0 70px 20px; display: flex; align-items: center;">
                <span>{{ $t('gongdanzhixing') }}</span>
<!--                <el-button type="primary" size="mini" style="margin-left: 10px;" @click="showUserPersonalConfigDialog">{{ $t('yonghugexinghuapeizhi') }}</el-button>-->
              </p>
              <div style="display: flex;width: 100%;justify-content: center;height: 320px;">
                <el-transfer ref="transfer" target-order="push" style="text-align: left; display: inline-block" v-model="showColumns" :titles="[$t('yincanglie'), $t('xianshilie')]" :format="{ noChecked: '${total}', hasChecked: '${checked}/${total}' }" @change="showColumnsChange" :data="generateTransferColumns">
                  <span slot-scope="{ option }">
                    <span>{{ $t(option.label) }}</span>
                    <span v-if="showColumns.length > 0 && showColumns.includes(option.key)">
                      <em v-if="showColumns[0] !== option.key" class="el-icon-top" style="cursor: pointer; margin-left: 5px;" @click.stop.prevent="changeCommonColumns('up', option.key, showColumns)"></em>
                      <em v-if="showColumns[showColumns.length - 1] !== option.key" class="el-icon-bottom" style="cursor: pointer; margin-left: 5px;" @click.stop.prevent="changeCommonColumns('down', option.key, showColumns)"></em>
                    </span>
                  </span>
                </el-transfer>
              </div>
              <p style="font-size: 16px; margin: 0 70px 20px">{{ $t('gongdanxiangqing') }}</p>
              <div style="display: flex;width: 100%;justify-content: center;height: 320px;">
                <el-transfer ref="transfer2" target-order="push" style="text-align: left; display: inline-block" v-model="detailShowColumns" :titles="[$t('yincanglie'), $t('xianshilie')]" :format="{ noChecked: '${total}', hasChecked: '${checked}/${total}' }" @change="detailShowColumnsChange" :data="detailColumns">
                  <span slot-scope="{ option }">
                    <span>{{ $t(option.label) }}</span>
                    <span v-if="detailShowColumns.length > 0 && detailShowColumns.includes(option.key)">
                      <em v-if="detailShowColumns[0] !== option.key" class="el-icon-top" style="cursor: pointer; margin-left: 5px;" @click.stop.prevent="changeCommonColumns('up', option.key, detailShowColumns)"></em>
                      <em v-if="detailShowColumns[detailShowColumns.length - 1] !== option.key" class="el-icon-bottom" style="cursor: pointer; margin-left: 5px;" @click.stop.prevent="changeCommonColumns('down', option.key, detailShowColumns)"></em>
                    </span>
                  </span>
                </el-transfer>
              </div>
            </div>
            <div v-else-if="yt.editObj.type === '60'">
              <el-form-item :label="$t('shifouqiyong')" required>
                <el-select v-model="yt.editObj.status" @change="$forceUpdate()">
                  <el-option :label="$t('shi')" :value="1"></el-option>
                  <el-option :label="$t('fou')" :value="0"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('shebeimingcheng')">
                <el-row>
                  <el-col :span="20">
                    <yi_data_select :max="1" :type="'equipment'" :ids.sync="yt.editObj.equipmentIds"></yi_data_select>
                  </el-col>
                </el-row>
              </el-form-item>
              <el-form-item :label="$t('beizhu')">
                <el-input type="textarea" v-model="yt.editObj.remark"></el-input>
              </el-form-item>
            </div>
            <div v-else-if="yt.editObj.type === '62'">
              <el-form-item :label="$t('shifouqiyong')" required>
                <el-select v-model="yt.editObj.status" @change="$forceUpdate()">
                  <el-option :label="$t('shi')" :value="1"></el-option>
                  <el-option :label="$t('fou')" :value="0"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('beizhu')">
                <el-input type="textarea" v-model="yt.editObj.remark"></el-input>
              </el-form-item>
              <el-form-item :label="$t('jiaoyanziduan')" required>
                <el-radio v-model="configJson.validateItem" label="ERPNum">{{ $t('lingliaoqitaoshu') }}</el-radio>
                <el-radio v-model="configJson.validateItem" label="feedingNum">{{ $t('touliaoqitaoshuliang') + '/' + $t('feedingQuantity') }}</el-radio>
              </el-form-item>
            </div>

            <div v-else-if="yt.editObj.type === '66'">
              <el-form-item :label="$t('shifouqiyong')" required>
                <el-select v-model="yt.editObj.status" @change="$forceUpdate()">
                  <el-option :label="$t('shi')" :value="1"></el-option>
                  <el-option :label="$t('fou')" :value="0"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('beizhu')">
                <el-input type="textarea" v-model="yt.editObj.remark"></el-input>
              </el-form-item>
              <el-form-item :label="$t('baoyangdanzidongwancheng')" required>
                <el-select v-model="configJson.finish" @change="$forceUpdate()">
                  <el-option :label="$t('shi')" :value="1"></el-option>
                  <el-option :label="$t('fou')" :value="0"></el-option>
                </el-select>
              </el-form-item>
            </div>
            <div v-else-if="yt.editObj.type === '63'">
              <el-form-item :label="$t('shifouqiyong')" required>
                <el-select v-model="yt.editObj.status" @change="$forceUpdate()">
                  <el-option :label="$t('shi')" :value="1"></el-option>
                  <el-option :label="$t('fou')" :value="0"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('baoyangneirongkexuan')">
                <el-select v-model="configJson.isMaintainItemSelectable" @change="$forceUpdate()">
                  <el-option :label="$t('shi')" :value="1"></el-option>
                  <el-option :label="$t('fou')" :value="0"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('baoyangdanzidongwancheng')">
                <el-select v-model="configJson.isMaintainBillAutoComplete" @change="$forceUpdate()">
                  <el-option :label="$t('shi')" :value="1"></el-option>
                  <el-option :label="$t('fou')" :value="0"></el-option>
                </el-select>
              </el-form-item>

              <el-form-item :label="$t('beizhu')">
                <el-input type="textarea" v-model="yt.editObj.remark"></el-input>
              </el-form-item>
            </div>
            <div v-else-if="yt.editObj.type === '72'">
              <el-form-item :label="$t('shifouqiyong')" required>
                <el-select v-model="yt.editObj.status">
                  <el-option :label="$t('shi')" :value="1"></el-option>
                  <el-option :label="$t('fou')" :value="0"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('beizhu')">
                <el-input type="textarea" v-model="yt.editObj.remark"></el-input>
              </el-form-item>
              <el-form-item :label="$t('xianzhishichang(h)')" required>
                <el-input-number v-model="configJson.limitHour" controls-position="right" :min="1" :max="24" :precision="0" :step="1"></el-input-number>
              </el-form-item>
            </div>
            <div v-else-if="yt.editObj.type === '78'">
              <el-form-item :label="$t('shifouqiyong')" required>
                <el-select v-model="yt.editObj.status">
                  <el-option :label="$t('shi')" :value="1"></el-option>
                  <el-option :label="$t('fou')" :value="0"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('beizhu')">
                <el-input type="textarea" v-model="yt.editObj.remark" maxlength="400" show-word-limit></el-input>
              </el-form-item>
              <el-form-item :label="$t('xianzhishichang(h)')" required>
                <el-input-number v-model="configJson.limitHour" controls-position="right" :min="1" :precision="0" :step="1"></el-input-number>
              </el-form-item>
            </div>
            <div v-else-if="yt.editObj.type === '75'">
              <el-form-item :label="$t('shifouqiyong')" required>
                <el-select v-model="yt.editObj.status" @change="$forceUpdate()" style="margin-left: 0px;">
                  <el-option :label="$t('shi')" :value="1"></el-option>
                  <el-option :label="$t('fou')" :value="0"></el-option>
                </el-select>
              </el-form-item>

              <el-form-item :label="$t('beizhu')">
                <el-input type="textarea" v-model="yt.editObj.remark"></el-input>
              </el-form-item>
              <div>
                <!-- 广播接口地址 -->
                <el-form-item :label="$t('guangbojiekoudizhi')" required>
                  <el-input v-model="configJson.broadcastUrl" placeholder="请输入广播接口地址" maxlength="200" show-word-limit></el-input>
                </el-form-item>
                <!-- 接口key -->
                <el-form-item :label="$t('jiekoukey')" required>
                  <el-input v-model="configJson.secretKey" placeholder="请输入接口key" maxlength="200" show-word-limit></el-input>
                </el-form-item>
                <!-- 音响设备编码 -->
                <el-form-item :label="$t('yinxiangshebeibianma')" required>
                  <el-input v-model="configJson.deviceCodes" placeholder="请输入音响设备编码" maxlength="200" show-word-limit></el-input>
                </el-form-item>

                <!-- 循环次数 -->
                <el-form-item :label="$t('xunhuanchici')" required>
                  <el-input-number
                    v-model="configJson.loopCount"
                    :min="1"
                    :max="10"
                    :step="1"
                    controls-position="right"
                    style="width: 100%"
                    :value="1"
                  ></el-input-number>
                </el-form-item>

                <!-- 循环间隔时间(秒) -->
                <el-form-item :label="$t('xunhuanjiangezhongji(miao)')" required>
                  <el-input-number
                    v-model="configJson.loopInterval"
                    :min="1"
                    :max="10"
                    :step="1"
                    controls-position="right"
                    style="width: 60%"
                    :value="3"
                  ></el-input-number>
                </el-form-item>

                <!-- 播放最长时间(秒) -->
                <el-form-item :label="$t('bopiaozuichangshijian(miao)')" required>
                  <el-input-number
                    v-model="configJson.maxPlayTime"
                    :min="60"
                    :max="120"
                    :step="1"
                    controls-position="right"
                    style="width: 60%"
                    :value="60"
                  ></el-input-number>
                </el-form-item>

                <!-- 触发异常广播内容 -->
                <el-form-item :label="$t('chufaichangguangboneirong')" required>
                  <el-input
                    v-model="configJson.exceptionBroadcastContent"
                    type="textarea"
                    placeholder="请输入触发异常广播内容"
                    maxlength="400"
                    show-word-limit
                    :rows="5"
                    :value="'设备名称{设备名称}，安灯描述{异常描述}，请及时处理'"
                  ></el-input>
                </el-form-item>

                <!-- 安灯确认超时广播内容 -->
                <el-form-item :label="$t('andengquerenchaozhiaguangbo')" required>
                  <el-input
                    v-model="configJson.confirmTimeoutBroadcastContent"
                    type="textarea"
                    placeholder="请输入安灯确认超时广播内容"
                    maxlength="400"
                    show-word-limit
                    :rows="5"
                    :value="'确认安灯超时，设备名称{设备名称}，安灯描述{异常描述}，请及时处理'"
                  ></el-input>
                </el-form-item>

                <!-- 安灯处理超时广播内容 -->
                <el-form-item :label="$t('andengchulichaozhiaguangbo')" required >
                  <el-input
                    v-model="configJson.processTimeoutBroadcastContent"
                    type="textarea"
                    placeholder="请输入安灯处理超时广播内容"
                    maxlength="400"
                    show-word-limit
                    :rows="5"
                    :value="'处理安灯超时，设备名称{设备名称}，安灯描述{异常描述}，请及时处理'"
                  ></el-input>
                </el-form-item>
              </div>
            </div>
            <div v-else-if="yt.editObj.type === '76'">
              <el-form-item :label="$t('shifouqiyong')" required>
                <el-select v-model="yt.editObj.status" @change="$forceUpdate()" style="margin-left: 0px;">
                  <el-option :label="$t('shi')" :value="1"></el-option>
                  <el-option :label="$t('fou')" :value="0"></el-option>
                </el-select>
              </el-form-item>
              <!-- 广播接口地址 -->
              <el-form-item :label="$t('guangbojiekoudizhi')" required>
                <el-input v-model="configJson.broadcastUrl" placeholder="请输入广播接口地址" maxlength="200" show-word-limit></el-input>
              </el-form-item>
              <!-- 接口key -->
              <el-form-item :label="$t('jiekoukey')" required>
                <el-input v-model="configJson.secretKey" placeholder="请输入接口key" maxlength="200" show-word-limit></el-input>
              </el-form-item>
              <!-- 音响设备编码 -->
              <el-form-item :label="$t('yinxiangshebeibianma')" required>
                <el-input v-model="configJson.deviceCodes" placeholder="请输入音响设备编码" maxlength="200" show-word-limit></el-input>
              </el-form-item>
              <!-- 循环次数 -->
              <el-form-item :label="$t('xunhuanchici')" required>
                <el-input-number v-model="configJson.loopCount" :min="1" :max="10" :step="1" controls-position="right" style="width: 100%" :value="1" ></el-input-number>
              </el-form-item>
              <!-- 循环间隔时间(秒) -->
              <el-form-item :label="$t('xunhuanjiangezhongji(miao)')" required>
                <el-input-number v-model="configJson.loopInterval" :min="1" :max="10" :step="1" controls-position="right" style="width: 60%" :value="3"></el-input-number>
              </el-form-item>
              <!-- 播放最长时间(秒) -->
              <el-form-item :label="$t('bopiaozuichangshijian(miao)')" required>
                <el-input-number v-model="configJson.maxPlayTime" :min="60" :max="120" :step="1" controls-position="right" style="width: 60%" :value="120"></el-input-number>
              </el-form-item>
              <!-- 安灯状态 -->
              <el-form-item :label="$t('andengzhuangtai')" required>
                <el-select v-model="configJson.andonStatus">
                  <el-option :label="$t('daiqueren')" :value="0"></el-option>
                  <el-option :label="$t('daichuli')" :value="1"></el-option>
                  <el-option :label="$t('yichuli')" :value="2"></el-option>
                </el-select>
              </el-form-item>
              <!-- 广播内容 -->
              <el-form-item :label="$t('chufaichangguangboneirong')" required>
                <el-input v-model="configJson.broadcastContent" type="textarea" placeholder="请输入触发异常广播内容" maxlength="400" show-word-limit :rows="5" :value="'设备名称{设备名称}，安灯描述{异常描述}，请及时处理'" ></el-input>
              </el-form-item>
              <!-- 广播时间 -->
              <el-form-item :label="$t('guangboshijian')" required>
                <el-radio v-model="configJson.broadcastTime" label="1">一直循环播放</el-radio>
                <el-radio v-model="configJson.broadcastTime" label="2">指定时间播放</el-radio>
                <el-select v-if="configJson.broadcastTime == 2" v-model="configJson.timeList" multiple filterable allow-create default-first-option @change="filterTimeOptions" placeholder="请以小时:分钟为格式">
                  <el-option v-for="item in timeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('beizhu')">
                <el-input type="textarea" v-model="yt.editObj.remark"></el-input>
              </el-form-item>
              <div style="color: #67C23A;font-size: 14px">变量说明：广播内容可拼接变量：{设备名称}、{异常描述}</div>
            </div>
          </el-form>
          <div v-if="yt.editObj.type === '0'">
            <el-form class="_form">
              <el-form-item v-for="(item, index) in yt.editObj.productionConfigDetailsList" :key="index" size="mini">
                <el-col :span="0.1">
                  <el-button type="text" icon="el-icon-remove-outline" @click="deleteItem(index)"></el-button>
                </el-col>
                <el-col :span="0.2">&nbsp;</el-col>
                <el-col :span="3">
                  <yi_data_select :type="'customerRole'" :ids.sync="item.roleId"></yi_data_select>
                </el-col>
                <el-col :span="4">&nbsp;</el-col>
                <el-col :span="3">
                  <el-input v-model="item.reportingInterval" type="number" oninput="value=value.replace(/^0|[^0-9]/g, '')" size="mini"></el-input>
                </el-col>
                <el-col :span="4">&nbsp;</el-col>
                <el-col :span="3">
                  <el-select v-model="item.effect">
                    <el-option :label="$t('xianzhi')" :value="1"></el-option>
                    <el-option :label="$t('tishi')" :value="0"></el-option>
                  </el-select>
                </el-col>
              </el-form-item>
              <br />
              <el-form-item size="mini" style="margin-top: -20px;">
                <el-col :span="2">
                  <el-button type="text" icon="el-icon-circle-plus-outline" @click="addItem">
                    {{ $t('zengjiayitiaopeizhixiang') }}
                  </el-button>
                </el-col>
              </el-form-item>
            </el-form>
          </div>
        </div>

        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="yt.editObj.loading" size="mini" @click="yt.req('POST', '/web/production/config/create', beforeReq)" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
      <!-- 编辑弹窗 -->
      <template v-if="yt.editObj.action == 'bianji'">
        <div class="dialog-scroller">
          <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
            <el-form-item class="noborder" :label="$t('shengchanpeizhileixing')">
              <yi_dictionary_select disabled type="PRODUCTION_CONFIG_TYPE" :ids.sync="yt.editObj.type"></yi_dictionary_select>
            </el-form-item>

            <template v-if="yt.editObj.type === '0'">
              <el-form-item :label="$t('shifouqiyong')" required>
                <el-select v-model="yt.editObj.status">
                  <el-option :label="$t('shi')" :value="1"></el-option>
                  <el-option :label="$t('fou')" :value="0"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('beizhu')">
                <el-input type="textarea" v-model="yt.editObj.remark"></el-input>
              </el-form-item>
              <p style="font-size: 18px;">{{ $t('peizhixinxi') }}</p>
              <el-form-item style="margin-left: -30px;" :label="$t('juese')" label-width="130px" required></el-form-item>
              <el-form-item style="margin-left: 150px;" :label="$t('baogongjiange(xiaoshi)')" label-width="130px" required></el-form-item>
              <el-form-item style="margin-left: 70px;" :label="$t('jiangexiaoguo')" label-width="105px" required></el-form-item>
            </template>
            <template v-else-if="yt.editObj.type === '1'">
              <el-form-item :label="$t('shifouqiyong')" required>
                <el-select v-model="yt.editObj.status">
                  <el-option :label="$t('shi')" :value="1"></el-option>
                  <el-option :label="$t('fou')" :value="0"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('beizhu')">
                <el-input type="textarea" v-model="yt.editObj.remark"></el-input>
              </el-form-item>
              <el-form-item :label="$t('chaochanleixing')" required>
                <el-select v-model="yt.editObj.overType">
                  <el-option :label="$t('bili')" :value="0"></el-option>
                  <el-option :label="$t('shuliang')" :value="1"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('chaochanzhi')" required>
                <el-input type="number" oninput="value=value.replace(/^0|[^0-9]/g, '')" v-model="yt.editObj.overValue" size="mini"></el-input>
              </el-form-item>
              <p class="work">
                <i style="margin-left: -270px;" class="yicon yicon-tips">{{ $t('shilishuoming') }}</i>
                <span>{{ $t('bilishuoming') }}</span>
                <span>{{ $t('shuliangshuoming') }}</span>
              </p>
            </template>
            <template v-else-if="defaultTypeList.indexOf(yt.editObj.type) > -1">
              <el-form-item :label="$t('shifouqiyong')" required>
                <el-select v-model="yt.editObj.status">
                  <el-option :label="$t('shi')" :value="1"></el-option>
                  <el-option :label="$t('fou')" :value="0"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('beizhu')">
                <el-input type="textarea" v-model="yt.editObj.remark"></el-input>
              </el-form-item>
            </template>
            <template v-else-if="yt.editObj.type === '3'">
              <el-form-item :label="$t('shifouqiyong')" required>
                <el-select v-model="yt.editObj.status" @change="$forceUpdate()">
                  <el-option :label="$t('shi')" :value="1"></el-option>
                  <el-option :label="$t('fou')" :value="0"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('beizhu')">
                <el-input type="textarea" v-model="yt.editObj.remark"></el-input>
              </el-form-item>
            </template>
            <template v-else-if="yt.editObj.type === '4'">
              <el-form-item :label="$t('mujuzhuangtai')" required>
                <yi_dictionary_select :max="999" multiple :type="'BASIC_MOULD_STATUS'" :ids.sync="yt.editObj.mouldStatus"></yi_dictionary_select>
              </el-form-item>
              <el-form-item :label="$t('shifouqiyong')" required>
                <el-select v-model="yt.editObj.status" @change="$forceUpdate()">
                  <el-option :label="$t('shi')" :value="1"></el-option>
                  <el-option :label="$t('fou')" :value="0"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('beizhu')">
                <el-input type="textarea" v-model="yt.editObj.remark"></el-input>
              </el-form-item>
            </template>
            <template v-else-if="yt.editObj.type === '79'">
              <el-form-item label="模具维修验收状态" required>
                <yi_dictionary_select :max="999" multiple :type="'EQUIPMENT_ACCEPTANCE_STATUS'" :ids.sync="yt.editObj.mouldStatus"></yi_dictionary_select>
              </el-form-item>
              <el-form-item :label="$t('shifouqiyong')" required>
                <el-select v-model="yt.editObj.status" @change="$forceUpdate()">
                  <el-option :label="$t('shi')" :value="1"></el-option>
                  <el-option :label="$t('fou')" :value="0"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('beizhu')">
                <el-input type="textarea" maxlength="400" show-word-limit v-model="yt.editObj.remark"></el-input>
              </el-form-item>
            </template>
            <div v-else-if="yt.editObj.type === '7'">
              <el-form-item :label="$t('shifouqiyong')" required>
                <el-select v-model="yt.editObj.status">
                  <el-option :label="$t('shi')" :value="1"></el-option>
                  <el-option :label="$t('fou')" :value="0"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('beizhu')">
                <el-input type="textarea" v-model="yt.editObj.remark"></el-input>
              </el-form-item>
              <!--工单限制数量，0或者无不限制数量              -->
              <el-form-item :label="$t('gongdanxianzhishuliang')">
                <el-input-number v-model="configJson.limitNum"></el-input-number>
              </el-form-item>
            </div>
            <template v-else-if="yt.editObj.type === '11'">
              <el-form-item :label="$t('gongdanzhuangtai')" required>
                <yi_dictionary_select :max="8" multiple :type="'PRODUCTION_WO_STATUS'" :ids.sync="yt.editObj.woStatus"></yi_dictionary_select>
              </el-form-item>
              <el-form-item :label="$t('shifouqiyong')" required>
                <el-select v-model="yt.editObj.status" @change="$forceUpdate()">
                  <el-option :label="$t('shi')" :value="1"></el-option>
                  <el-option :label="$t('fou')" :value="0"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('beizhu')">
                <el-input type="textarea" v-model="yt.editObj.remark"></el-input>
              </el-form-item>
            </template>

            <div v-else-if="yt.editObj.type === '12'">
              <el-form-item :label="$t('gongdanyouxianji')" required>
                <el-select v-model="yt.editObj.woStartPriority" @change="$forceUpdate()">
                  <el-option :label="$t('gongdanshunxu')" value="0"></el-option>
                  <el-option :label="$t('jihuakaishishijian')" value="1"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('shifouqiyong')" required>
                <el-select v-model="yt.editObj.status" @change="$forceUpdate()">
                  <el-option :label="$t('shi')" :value="1"></el-option>
                  <el-option :label="$t('fou')" :value="0"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('beizhu')">
                <el-input type="textarea" v-model="yt.editObj.remark"></el-input>
              </el-form-item>
            </div>
            <div v-else-if="yt.editObj.type === '13'">
              <el-form-item :label="$t('shifouqiyong')" required>
                <el-select v-model="yt.editObj.status" @change="$forceUpdate()">
                  <el-option :label="$t('shi')" :value="1"></el-option>
                  <el-option :label="$t('fou')" :value="0"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('beizhu')">
                <el-input type="textarea" v-model="yt.editObj.remark"></el-input>
              </el-form-item>
            </div>
            <div v-else-if="yt.editObj.type === '14'">
              <el-form-item :label="$t('shifouqiyong')" required>
                <el-select v-model="yt.editObj.status" @change="$forceUpdate()">
                  <el-option :label="$t('shi')" :value="1"></el-option>
                  <el-option :label="$t('fou')" :value="0"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('beizhu')">
                <el-input type="textarea" v-model="yt.editObj.remark"></el-input>
              </el-form-item>
            </div>
            <div v-else-if="yt.editObj.type === '15'">
              <el-form-item :label="$t('shifouqiyong')" required>
                <el-select v-model="yt.editObj.status" @change="$forceUpdate()">
                  <el-option :label="$t('shi')" :value="1"></el-option>
                  <el-option :label="$t('fou')" :value="0"></el-option>
                </el-select>
              </el-form-item>
              <div style="display: flex;">
                <el-form-item :label="$t('zuidazhangshu') + '(1-50)'" required>
                  <el-input-number :min="1" :max="50" step-strictly v-model="yt.editObj.overValue"></el-input-number>
                </el-form-item>
              </div>
              <el-form-item :label="$t('beizhu')">
                <el-input type="textarea" v-model="yt.editObj.remark"></el-input>
              </el-form-item>
            </div>

            <div v-else-if="yt.editObj.type === '22'">
              <el-form-item :label="$t('shifouqiyong')" required>
                <el-select v-model="yt.editObj.status" @change="$forceUpdate()">
                  <el-option :label="$t('shi')" :value="1"></el-option>
                  <el-option :label="$t('fou')" :value="0"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('shebeimingcheng')">
                <el-row>
                  <el-col :span="20">
                    <yi_data_select ref="equipmentSelect" :multiple="true" :type="'equipment'" :ids.sync="yt.editObj.equipmentIds"></yi_data_select>
                  </el-col>
                  <el-col :span="4">
                    <el-button type="text" @click="selectAll()">{{ $t('quanxuan') }}</el-button>
                  </el-col>
                </el-row>
              </el-form-item>

              <el-form-item :label="$t('baogongren')">
                <yi_data_select :type="'customer_user'" :ids.sync="configJson.reportId"></yi_data_select>
              </el-form-item>

              <el-form-item :label="$t('自动计算产量')">
                <el-checkbox v-model="configJson.checked"></el-checkbox>
              </el-form-item>

              <el-form-item :label="$t('beizhu')">
                <el-input type="textarea" v-model="yt.editObj.remark"></el-input>
              </el-form-item>
            </div>

            <div v-else-if="yt.editObj.type === '24'">
              <el-form-item :label="$t('shifouqiyong')" required>
                <el-select v-model="yt.editObj.status" @change="$forceUpdate()">
                  <el-option :label="$t('shi')" :value="1"></el-option>
                  <el-option :label="$t('fou')" :value="0"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('beizhu')">
                <el-input type="textarea" v-model="yt.editObj.remark"></el-input>
              </el-form-item>
            </div>

            <div v-else-if="yt.editObj.type === '25'">
              <el-form-item :label="$t('shifouqiyong')" required>
                <el-select v-model="yt.editObj.status" @change="$forceUpdate()">
                  <el-option :label="$t('shi')" :value="1"></el-option>
                  <el-option :label="$t('fou')" :value="0"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('beizhu')">
                <el-input type="textarea" v-model="yt.editObj.remark"></el-input>
              </el-form-item>
            </div>

            <div v-else-if="yt.editObj.type === '16'">
              <el-form-item :label="$t('shifouqiyong')" required>
                <el-select v-model="yt.editObj.status" @change="$forceUpdate()">
                  <el-option :label="$t('shi')" :value="1"></el-option>
                  <el-option :label="$t('fou')" :value="0"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('beizhu')">
                <el-input type="textarea" v-model="yt.editObj.remark"></el-input>
              </el-form-item>
            </div>
            <div v-else-if="yt.editObj.type === '29'">
              <el-form-item :label="$t('tongzhiyonghu')" required>
                <yi_data_select :multiple="true" :type="'customer_user'" :ids.sync="yt.editObj.equipmentIds"></yi_data_select>
              </el-form-item>
              <el-form-item :label="$t('shifouqiyong')" required>
                <el-select v-model="yt.editObj.status" @change="$forceUpdate()">
                  <el-option :label="$t('shi')" :value="1"></el-option>
                  <el-option :label="$t('fou')" :value="0"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('beizhu')">
                <el-input type="textarea" v-model="yt.editObj.remark"></el-input>
              </el-form-item>
            </div>
            <div v-else-if="yt.editObj.type === '31'">
              <el-form-item :label="$t('shifouqiyong')" required>
                <el-select v-model="yt.editObj.status" @change="$forceUpdate()">
                  <el-option :label="$t('shi')" :value="1"></el-option>
                  <el-option :label="$t('fou')" :value="0"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('beizhu')">
                <el-input type="textarea" v-model="yt.editObj.remark"></el-input>
              </el-form-item>
              <div v-if="yt.editObj.status === 1">
                <el-form-item :label="$t('xieyi')">
                  <el-select v-model="configJson.protocol" style="flex: 1;">
                    <el-option v-for="(h, i) in ['http://', 'https://']" :key="i" :label="h" :value="h"> </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item :label="$t('zhuji')">
                  <el-input style="flex: 4;" type="text" placeholder="ip:port" v-model="configJson.host"></el-input>
                </el-form-item>
                <el-form-item label="AppKey">
                  <el-input type="text" v-model="configJson.appKey"></el-input>
                </el-form-item>
                <el-form-item label="AppSecret">
                  <el-input type="text" v-model="configJson.appSecret"></el-input>
                </el-form-item>
                <el-form-item :label="$t('jiekoushangxiawenlujin')">
                  <el-input type="text" v-model="configJson.contextPath" placeholder="/"></el-input>
                </el-form-item>
                <el-form-item :label="$t('jiankongdianweiyibiaoshi')">
                  <div style="display: flex;">
                    <el-input type="text" v-model="configJson.indexCode"></el-input>
                    <el-tooltip :content="$t('duogeyongdouhaogekai')" placement="right" style="margin: auto 5px;">
                      <i class="el-icon-question"></i>
                    </el-tooltip>
                  </div>
                </el-form-item>
              </div>
            </div>
            <div v-else-if="yt.editObj.type === '33'">
              <el-form-item :label="$t('shifouqiyong')" required>
                <el-select v-model="yt.editObj.status" @change="$forceUpdate()">
                  <el-option :label="$t('shi')" :value="1"></el-option>
                  <el-option :label="$t('fou')" :value="0"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('beizhu')">
                <el-input type="textarea" v-model="yt.editObj.remark"></el-input>
              </el-form-item>
              <p style="font-size: 16px; margin: 0 70px 20px; display: flex; align-items: center;">
                <span>{{ $t('gongdanzhixing') }}</span>
                <el-button type="primary" size="mini" style="margin-left: 10px;" @click="showUserPersonalConfigDialog">{{ $t('yonghugexinghuapeizhi') }}</el-button>
              </p>
              <div style="display: flex;width: 100%;justify-content: center;height: 320px;">
                <el-transfer ref="transfer" target-order="push" style="text-align: left; display: inline-block" v-model="showColumns" :titles="[$t('yincanglie'), $t('xianshilie')]" :format="{ noChecked: '${total}', hasChecked: '${checked}/${total}' }" @change="showColumnsChange" :data="generateTransferColumns">
                  <span slot-scope="{ option }">
                    <span>{{ option.label }}</span>
                    <span v-if="showColumns.length > 0 && showColumns.includes(option.key)">
                      <em v-if="showColumns[0] !== option.key" class="el-icon-top" @click.stop.prevent="changeCommonColumns('up', option.key, showColumns)"></em>
                      <em v-if="showColumns[showColumns.length - 1] !== option.key" class="el-icon-bottom" @click.stop.prevent="changeCommonColumns('down', option.key, showColumns)"></em>
                    </span>
                  </span>
                </el-transfer>
              </div>
              <p style="font-size: 16px; margin: 0 70px 20px">{{ $t('gongdanxiangqing') }}</p>
              <div style="display: flex;width: 100%;justify-content: center;height: 320px;">
                <el-transfer ref="transfer2" target-order="push" style="text-align: left; display: inline-block" v-model="detailShowColumns" :titles="[$t('yincanglie'), $t('xianshilie')]" :format="{ noChecked: '${total}', hasChecked: '${checked}/${total}' }" @change="detailShowColumnsChange" :data="detailColumns">
                  <span slot-scope="{ option }">
                    <span>{{ $t(option.label) }}</span>
                    <span v-if="detailShowColumns.length > 0 && detailShowColumns.includes(option.key)">
                      <em v-if="detailShowColumns[0] !== option.key" class="el-icon-top" style="cursor: pointer; margin-left: 5px;" @click.stop.prevent="changeCommonColumns('up', option.key, detailShowColumns)"></em>
                      <em v-if="detailShowColumns[detailShowColumns.length - 1] !== option.key" class="el-icon-bottom" style="cursor: pointer; margin-left: 5px;" @click.stop.prevent="changeCommonColumns('down', option.key, detailShowColumns)"></em>
                    </span>
                  </span>
                </el-transfer>
              </div>
            </div>

            <div v-else-if="yt.editObj.type === '60'">
              <el-form-item :label="$t('shifouqiyong')" required>
                <el-select v-model="yt.editObj.status" @change="$forceUpdate()">
                  <el-option :label="$t('shi')" :value="1"></el-option>
                  <el-option :label="$t('fou')" :value="0"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('shebeimingcheng')">
                <yi_data_select :max="1" :type="'equipment'" :ids.sync="yt.editObj.equipmentIds"></yi_data_select>
              </el-form-item>

              <el-form-item :label="$t('beizhu')">
                <el-input type="textarea" v-model="yt.editObj.remark"></el-input>
              </el-form-item>
            </div>

            <div v-else-if="yt.editObj.type === '62'">
              <el-form-item :label="$t('shifouqiyong')" required>
                <el-select v-model="yt.editObj.status" @change="$forceUpdate()">
                  <el-option :label="$t('shi')" :value="1"></el-option>
                  <el-option :label="$t('fou')" :value="0"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('beizhu')">
                <el-input type="textarea" v-model="yt.editObj.remark"></el-input>
              </el-form-item>
              <el-form-item :label="$t('jiaoyanziduan')" required>
                <el-radio v-model="configJson.validateItem" label="ERPNum">{{ $t('lingliaoqitaoshu') }}</el-radio>
                <el-radio v-model="configJson.validateItem" label="feedingNum">{{ $t('touliaoqitaoshuliang') + '/' + $t('feedingQuantity') }}</el-radio>
              </el-form-item>
            </div>

            <div v-else-if="yt.editObj.type === '66'">
              <el-form-item :label="$t('shifouqiyong')" required>
                <el-select v-model="yt.editObj.status" @change="$forceUpdate()">
                  <el-option :label="$t('shi')" :value="1"></el-option>
                  <el-option :label="$t('fou')" :value="0"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('beizhu')">
                <el-input type="textarea" v-model="yt.editObj.remark"></el-input>
              </el-form-item>
              <el-form-item :label="$t('保养单自动完成')" required>
                <el-select v-model="configJson.finish" @change="$forceUpdate()">
                  <el-option :label="$t('shi')" :value="1"></el-option>
                  <el-option :label="$t('fou')" :value="0"></el-option>
                </el-select>
              </el-form-item>
            </div>
            <div v-else-if="yt.editObj.type === '63'">
              <el-form-item :label="$t('shifouqiyong')" required>
                <el-select v-model="yt.editObj.status" @change="$forceUpdate()">
                  <el-option :label="$t('shi')" :value="1"></el-option>
                  <el-option :label="$t('fou')" :value="0"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('baoyangneirongkexuan')">
                <el-select v-model="configJson.isMaintainItemSelectable" @change="$forceUpdate()">
                  <el-option :label="$t('shi')" :value="1"></el-option>
                  <el-option :label="$t('fou')" :value="0"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('baoyangdanzidongwancheng')">
                <el-select v-model="configJson.isMaintainBillAutoComplete" @change="$forceUpdate()">
                  <el-option :label="$t('shi')" :value="1"></el-option>
                  <el-option :label="$t('fou')" :value="0"></el-option>
                </el-select>
              </el-form-item>

              <el-form-item :label="$t('beizhu')">
                <el-input type="textarea" v-model="yt.editObj.remark"></el-input>
              </el-form-item>
            </div>
            <div v-else-if="yt.editObj.type === '72'">
              <el-form-item :label="$t('shifouqiyong')" required>
                <el-select v-model="yt.editObj.status">
                  <el-option :label="$t('shi')" :value="1"></el-option>
                  <el-option :label="$t('fou')" :value="0"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('beizhu')">
                <el-input type="textarea" v-model="yt.editObj.remark"></el-input>
              </el-form-item>
              <el-form-item :label="$t('xianzhishichang(h)')" required>
                <el-input-number v-model="configJson.limitHour" controls-position="right" :min="1" :max="24" :precision="0" :step="1"></el-input-number>
              </el-form-item>
            </div>
            <div v-else-if="yt.editObj.type === '78'">
              <el-form-item :label="$t('shifouqiyong')" required>
                <el-select v-model="yt.editObj.status">
                  <el-option :label="$t('shi')" :value="1"></el-option>
                  <el-option :label="$t('fou')" :value="0"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('beizhu')">
                <el-input type="textarea" v-model="yt.editObj.remark" maxlength="400" show-word-limit></el-input>
              </el-form-item>
              <el-form-item :label="$t('xianzhishichang(h)')" required>
                <el-input-number v-model="configJson.limitHour" controls-position="right" :min="1" :precision="0" :step="1"></el-input-number>
              </el-form-item>
            </div>
            <div v-else-if="yt.editObj.type === '75'">
              <el-form-item :label="$t('shifouqiyong')" required>
                <el-select v-model="yt.editObj.status" @change="$forceUpdate()" style="margin-left: 0px;">
                  <el-option :label="$t('shi')" :value="1"></el-option>
                  <el-option :label="$t('fou')" :value="0"></el-option>
                </el-select>
              </el-form-item>

              <el-form-item :label="$t('beizhu')">
                <el-input type="textarea" v-model="yt.editObj.remark"></el-input>
              </el-form-item>
              <div>
                <!-- 广播接口地址 -->
                <el-form-item :label="$t('guangbojiekoudizhi')" required>
                  <el-input v-model="configJson.broadcastUrl" placeholder="请输入广播接口地址" maxlength="200" show-word-limit></el-input>
                </el-form-item>
                <!-- 接口key -->
                <el-form-item :label="$t('jiekoukey')" required>
                  <el-input v-model="configJson.secretKey" placeholder="请输入接口key" maxlength="200" show-word-limit></el-input>
                </el-form-item>
                <!-- 音响设备编码 -->
                <el-form-item :label="$t('yinxiangshebeibianma')" required>
                  <el-input v-model="configJson.deviceCodes" placeholder="请输入音响设备编码" maxlength="200" show-word-limit></el-input>
                </el-form-item>

                <!-- 循环次数 -->
                <el-form-item :label="$t('xunhuanchici')" required>
                  <el-input-number
                    v-model="configJson.loopCount"
                    :min="1"
                    :max="10"
                    :step="1"
                    controls-position="right"
                    style="width: 100%"
                    :value="1"
                  ></el-input-number>
                </el-form-item>

                <!-- 循环间隔时间(秒) -->
                <el-form-item :label="$t('xunhuanjiangezhongji(miao)')" required>
                  <el-input-number
                    v-model="configJson.loopInterval"
                    :min="1"
                    :max="10"
                    :step="1"
                    controls-position="right"
                    style="width: 60%"
                    :value="3"
                  ></el-input-number>
                </el-form-item>

                <!-- 播放最长时间(秒) -->
                <el-form-item :label="$t('bopiaozuichangshijian(miao)')" required>
                  <el-input-number
                    v-model="configJson.maxPlayTime"
                    :min="60"
                    :max="120"
                    :step="1"
                    controls-position="right"
                    style="width: 60%"
                    :value="60"
                  ></el-input-number>
                </el-form-item>

                <!-- 触发异常广播内容 -->
                <el-form-item :label="$t('chufaichangguangboneirong')" required>
                  <el-input
                    v-model="configJson.exceptionBroadcastContent"
                    type="textarea"
                    placeholder="请输入触发异常广播内容"
                    maxlength="400"
                    show-word-limit
                    :rows="5"
                    :value="'设备名称{设备名称}，安灯描述{异常描述}，请及时处理'"
                  ></el-input>
                </el-form-item>

                <!-- 安灯确认超时广播内容 -->
                <el-form-item :label="$t('andengquerenchaozhiaguangbo')" required>
                  <el-input
                    v-model="configJson.confirmTimeoutBroadcastContent"
                    type="textarea"
                    placeholder="请输入安灯确认超时广播内容"
                    maxlength="400"
                    show-word-limit
                    :rows="5"
                    :value="'确认安灯超时，设备名称{设备名称}，安灯描述{异常描述}，请及时处理'"
                  ></el-input>
                </el-form-item>

                <!-- 安灯处理超时广播内容 -->
                <el-form-item :label="$t('andengchulichaozhiaguangbo')" required >
                  <el-input
                    v-model="configJson.processTimeoutBroadcastContent"
                    type="textarea"
                    placeholder="请输入安灯处理超时广播内容"
                    maxlength="400"
                    show-word-limit
                    :rows="5"
                    :value="'处理安灯超时，设备名称{设备名称}，安灯描述{异常描述}，请及时处理'"
                  ></el-input>
                </el-form-item>
              </div>
            </div>
            <div v-else-if="yt.editObj.type === '76'">
              <el-form-item :label="$t('shifouqiyong')" required>
                <el-select v-model="yt.editObj.status" @change="$forceUpdate()" style="margin-left: 0px;">
                  <el-option :label="$t('shi')" :value="1"></el-option>
                  <el-option :label="$t('fou')" :value="0"></el-option>
                </el-select>
              </el-form-item>
              <!-- 广播接口地址 -->
              <el-form-item :label="$t('guangbojiekoudizhi')" required>
                <el-input v-model="configJson.broadcastUrl" placeholder="请输入广播接口地址" maxlength="200" show-word-limit></el-input>
              </el-form-item>
              <!-- 接口key -->
              <el-form-item :label="$t('jiekoukey')" required>
                <el-input v-model="configJson.secretKey" placeholder="请输入接口key" maxlength="200" show-word-limit></el-input>
              </el-form-item>
              <!-- 音响设备编码 -->
              <el-form-item :label="$t('yinxiangshebeibianma')" required>
                <el-input v-model="configJson.deviceCodes" placeholder="请输入音响设备编码" maxlength="200" show-word-limit></el-input>
              </el-form-item>
              <!-- 循环次数 -->
              <el-form-item :label="$t('xunhuanchici')" required>
                <el-input-number v-model="configJson.loopCount" :min="1" :max="10" :step="1" controls-position="right" style="width: 100%" :value="1" ></el-input-number>
              </el-form-item>
              <!-- 循环间隔时间(秒) -->
              <el-form-item :label="$t('xunhuanjiangezhongji(miao)')" required>
                <el-input-number v-model="configJson.loopInterval" :min="1" :max="10" :step="1" controls-position="right" style="width: 60%" :value="3"></el-input-number>
              </el-form-item>
              <!-- 播放最长时间(秒) -->
              <el-form-item :label="$t('bopiaozuichangshijian(miao)')" required>
                <el-input-number v-model="configJson.maxPlayTime" :min="60" :max="120" :step="1" controls-position="right" style="width: 60%" :value="120"></el-input-number>
              </el-form-item>
              <!-- 安灯状态 -->
              <el-form-item :label="$t('andengzhuangtai')" required>
                <el-select v-model="configJson.andonStatus">
                  <el-option :label="$t('daiqueren')" :value="0"></el-option>
                  <el-option :label="$t('daichuli')" :value="1"></el-option>
                  <el-option :label="$t('yichuli')" :value="2"></el-option>
                </el-select>
              </el-form-item>
              <!-- 广播内容 -->
              <el-form-item :label="$t('chufaichangguangboneirong')" required>
                <el-input v-model="configJson.broadcastContent" type="textarea" placeholder="请输入触发异常广播内容" maxlength="400" show-word-limit :rows="5" :value="'设备名称{设备名称}，安灯描述{异常描述}，请及时处理'" ></el-input>
              </el-form-item>
              <!-- 广播时间 -->
              <el-form-item :label="$t('guangboshijian')" required>
                <el-radio v-model="configJson.broadcastTime" label="1">一直循环播放</el-radio>
                <el-radio v-model="configJson.broadcastTime" label="2">指定时间播放</el-radio>
                <el-select v-if="configJson.broadcastTime == 2" v-model="configJson.timeList" multiple filterable allow-create default-first-option @change="filterTimeOptions" placeholder="请以小时:分钟为格式">
                  <el-option v-for="item in timeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('beizhu')">
                <el-input type="textarea" v-model="yt.editObj.remark"></el-input>
              </el-form-item>
              <div style="color: #67C23A;font-size: 14px">变量说明：广播内容可拼接变量：{设备名称}、{异常描述}</div>
            </div>
          </el-form>

          <template v-if="yt.editObj.type === '0'">
            <el-form class="_form">
              <el-form-item v-for="(item, index) in yt.editObj.productionConfigDetailsList" :key="index" size="mini">
                <el-col :span="0.1">
                  <el-button type="text" icon="el-icon-remove-outline" @click="deleteItem(index)"></el-button>
                </el-col>
                <el-col :span="0.2">&nbsp;</el-col>
                <el-col :span="3">
                  <yi_data_select :type="'customerRole'" :ids.sync="item.roleId"></yi_data_select>
                </el-col>
                <el-col :span="4">&nbsp;</el-col>
                <el-col :span="3">
                  <el-input v-model="item.reportingInterval" type="number" oninput="value=value.replace(/^0|[^0-9]/g, '')" size="mini"></el-input>
                </el-col>
                <el-col :span="4">&nbsp;</el-col>
                <el-col :span="3">
                  <el-select v-model="item.effect">
                    <el-option :label="$t('xianzhi')" :value="1"></el-option>
                    <el-option :label="$t('tishi')" :value="0"></el-option>
                  </el-select>
                </el-col>
              </el-form-item>
              <br />
              <el-form-item size="mini" style="margin-top: -20px;">
                <el-col :span="2">
                  <el-button type="text" icon="el-icon-circle-plus-outline" @click="addItem">
                    {{ $t('zengjiayitiaopeizhixiang') }}
                  </el-button>
                </el-col>
              </el-form-item>
            </el-form>
          </template>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="yt.editObj.loading" size="mini" @click="yt.req('POST', '/web/production/config/update', beforeEditReq)" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
    </el-dialog>
    <!-- 用户个性化配置弹窗 -->
    <el-dialog :show-close="true" :title="$t('yonghumingcheng') +'：'+ currentUserName" :visible.sync="isShowUserPersonalConfigDialog" :width="'830px'" :close-on-click-modal="false" append-to-body="append-to-body">
      <div class="dialog-scroller">
        <p style="font-size: 16px; margin: 0 70px 20px">{{ $t('gongdanzhixing') }}</p>
        <div style="display: flex;width: 100%;justify-content: center;height: 320px;">
          <el-transfer ref="userPersonalTransfer" target-order="push" style="text-align: left; display: inline-block" v-model="userPersonalShowColumns" :titles="[$t('yincanglie'), $t('xianshilie')]" :format="{ noChecked: '${total}', hasChecked: '${checked}/${total}' }" @change="userPersonalShowColumnsChange" :data="userPersonalGenerateTransferColumns">
            <span slot-scope="{ option }">
              <span>{{ $t(option.label) }}</span>
              <span v-if="userPersonalShowColumns.length > 0 && userPersonalShowColumns.includes(option.key)">
                <em v-if="userPersonalShowColumns[0] !== option.key" class="el-icon-top" style="cursor: pointer; margin-left: 5px;" @click.stop.prevent="changeCommonColumns('up', option.key, userPersonalShowColumns)"></em>
                <em v-if="userPersonalShowColumns[userPersonalShowColumns.length - 1] !== option.key" class="el-icon-bottom" style="cursor: pointer; margin-left: 5px;" @click.stop.prevent="changeCommonColumns('down', option.key, userPersonalShowColumns)"></em>
              </span>
            </span>
          </el-transfer>
        </div>
        <p style="font-size: 16px; margin: 0 70px 20px">{{ $t('gongdanxiangqing') }}</p>
        <div style="display: flex;width: 100%;justify-content: center;height: 320px;">
          <el-transfer ref="userPersonalTransfer2" target-order="push" style="text-align: left; display: inline-block" v-model="userPersonalDetailShowColumns" :titles="[$t('yincanglie'), $t('xianshilie')]" :format="{ noChecked: '${total}', hasChecked: '${checked}/${total}' }" @change="userPersonalDetailShowColumnsChange" :data="userPersonalDetailColumns">
            <span slot-scope="{ option }">
              <span>{{ $t(option.label) }}</span>
              <span v-if="userPersonalDetailShowColumns.length > 0 && userPersonalDetailShowColumns.includes(option.key)">
                <em v-if="userPersonalDetailShowColumns[0] !== option.key" class="el-icon-top" style="cursor: pointer; margin-left: 5px;" @click.stop.prevent="changeCommonColumns('up', option.key, userPersonalDetailShowColumns)"></em>
                <em v-if="userPersonalDetailShowColumns[userPersonalDetailShowColumns.length - 1] !== option.key" class="el-icon-bottom" style="cursor: pointer; margin-left: 5px;" @click.stop.prevent="changeCommonColumns('down', option.key, userPersonalDetailShowColumns)"></em>
              </span>
            </span>
          </el-transfer>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="isShowUserPersonalConfigDialog = false">{{ $t('quxiao') }}</el-button>
        <el-button size="mini" @click="saveUserPersonalConfig" type="primary">
          {{ $t('baocun') }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script type="text/javascript">
export default {
  name: 'web_system_configuration_list',
  components: {},
  data() {
    return {
      configJson: {},
      defaultTypeList: ['2', '5', '6', '8', '9', '10', '14', '16', '17', '18', '19', '20', '21', '23', '26', '27', '28', '30', '34', '35', '54', '32', '55', '56', '57', '58', '59', '61', '64', '65', '67', '68', '69', '70', '71','73','74','77'],
      columns: [
        {
          label: 'shengchanpeizhileixing',
          prop: 'type',
          type: 'dictionary',
          key: 'PRODUCTION_CONFIG_TYPE'
        },
        {
          label: 'shifouqiyong',
          prop: 'erpNo',
          type: 'slot',
          width: 90
        },
        {
          label: 'chuangjianren',
          prop: 'createByObject.nickname'
        },
        {
          label: 'chuangjianshijian',
          prop: 'createTime',
          type: 'time',
          width: 180
        },
        {
          label: 'beizhu',
          prop: 'remark'
        },
        {
          label: 'caozuo',
          type: 'slot',
          width: 130,
          fixed: 'right'
        }
      ],
      showColumns: [],
      generateTransferColumns: [],
      detailColumns: [],
      detailShowColumns: [],
      selected: {},
      ids: '',
      // 用户个性化配置相关
      isShowUserPersonalConfigDialog: false,
      userPersonalShowColumns: [],
      userPersonalGenerateTransferColumns: [],
      userPersonalDetailColumns: [],
      userPersonalDetailShowColumns: [],
      userPersonalSelected: {},
      // 用于保存用户配置记录的 ID
      userPersonalConfigId: null,
      timeOptions: [],
    };
  },
  created() {
    setTimeout(() => {
      this.yt.conditions = {
        orderBy: 'createTime desc'
      };
      this.yt.get(1);
      this.yt.isShowPagination = true;
      this.generateTimeOptions();
    }, 300);
  },
  watch: {},
  methods: {
    selectAll() {
      let data = this.$refs['equipmentSelect'].items;
      let equipmentIds = [];
      data.forEach(item => {
        equipmentIds.push(item.id);
      });
      console.log(equipmentIds);
      this.yt.editObj.equipmentIds = equipmentIds;
    },
    beforeReq(params) {
      switch (params['type']) {
        case '0': {
          return {
            type: params['type'],
            productionConfigDetailsList: params['productionConfigDetailsList'],
            status: params['status'],
            remark: params['remark']
          };
          break;
        }
        case '1': {
          return {
            type: params['type'],
            status: params['status'],
            remark: params['remark'],
            overType: params['overType'],
            overValue: params['overValue']
          };
          break;
        }
        case '2': {
          return {
            type: params['type'],
            status: params['status'],
            remark: params['remark']
          };
          break;
        }
        case '3': {
          return {
            type: params['type'],
            status: params['status'],
            remark: params['remark']
          };
          break;
        }
        case '4': {
          return {
            type: params['type'],
            mouldStatus: params['mouldStatus'],
            status: params['status'],
            remark: params['remark']
          };
          break;
        }
        case '79': {
          return {
            type: params['type'],
            mouldStatus: params['mouldStatus'],
            status: params['status'],
            remark: params['remark']
          };
          break;
        }
        case '5': {
          return {
            type: params['type'],
            status: params['status'],
            remark: params['remark']
          };
          break;
        }
        case '6': {
          return {
            type: params['type'],
            status: params['status'],
            remark: params['remark']
          };
          break;
        }
        case '7': {
          return {
            type: params['type'],
            status: params['status'],
            configJson: this.configJson,
            remark: params['remark']
          };
          break;
        }
        case '8': {
          return {
            type: params['type'],
            status: params['status'],
            remark: params['remark']
          };
          break;
        }
        case '9': {
          return {
            type: params['type'],
            status: params['status'],
            remark: params['remark']
          };
          break;
        }
        case '10': {
          return {
            type: params['type'],
            status: params['status'],
            remark: params['remark']
          };
          break;
        }
        case '11': {
          return {
            type: params['type'],
            woStatus: params['woStatus'],
            status: params['status'],
            remark: params['remark']
          };
          break;
        }
        case '12': {
          return {
            type: params['type'],
            woStartPriority: params['woStartPriority'],
            status: params['status'],
            remark: params['remark']
          };
          break;
        }
        case '13': {
          return {
            type: params['type'],
            status: params['status'],
            remark: params['remark']
          };
          break;
        }
        case '14': {
          return {
            type: params['type'],
            status: params['status'],
            remark: params['remark']
          };
          break;
        }
        case '15': {
          return {
            type: params['type'],
            status: params['status'],
            overValue: params['overValue'],
            remark: params['remark']
          };
          break;
        }
        case '16': {
          return {
            type: params['type'],
            status: params['status'],
            remark: params['remark']
          };
          break;
        }
        case '17': {
          return {
            type: params['type'],
            status: params['status'],
            remark: params['remark']
          };
          break;
        }
        case '18': {
          return {
            type: params['type'],
            status: params['status'],
            remark: params['remark']
          };
          break;
        }
        case '19': {
          return {
            type: params['type'],
            status: params['status'],
            remark: params['remark']
          };
          break;
        }
        case '20': {
          return {
            type: params['type'],
            status: params['status'],
            remark: params['remark']
          };
          break;
        }
        case '21': {
          return {
            type: params['type'],
            status: params['status'],
            remark: params['remark']
          };
          break;
        }
        case '22': {
          return {
            type: params['type'],
            status: params['status'],
            equipmentIds: params['equipmentIds'],
            remark: params['remark'],
            configJson: this.configJson
          };
          break;
        }
        case '23': {
          return {
            type: params['type'],
            status: params['status'],
            remark: params['remark']
          };
          break;
        }
        case '24': {
          return {
            type: params['type'],
            status: params['status'],
            remark: params['remark']
          };
          break;
        }
        case '25': {
          return {
            type: params['type'],
            status: params['status'],
            remark: params['remark']
          };
          break;
        }
        case '26': {
          return {
            type: params['type'],
            status: params['status'],
            remark: params['remark']
          };
          break;
        }
        case '27': {
          return {
            type: params['type'],
            status: params['status'],
            remark: params['remark']
          };
          break;
        }
        case '28': {
          return {
            type: params['type'],
            status: params['status'],
            remark: params['remark']
          };
          break;
        }
        case '29': {
          return {
            type: params['type'],
            status: params['status'],
            equipmentIds: params['equipmentIds'],
            remark: params['remark']
          };
          break;
        }
        case '30': {
          return {
            type: params['type'],
            status: params['status'],
            remark: params['remark']
          };
          break;
        }
        case '54': {
          return {
            type: params['type'],
            status: params['status'],
            remark: params['remark']
          };
          break;
        }
        case '31': {
          const status = params['status'];
          let configJson = {};
          if (status === 1) {
            configJson = this.configJson;
          }
          return {
            type: params['type'],
            status: params['status'],
            remark: params['remark'],
            configJson: configJson
          };
          break;
        }
        case '32': {
          return {
            type: params['type'],
            status: params['status'],
            remark: params['remark']
          };
          break;
        }
        case '33': {
          return {
            type: params['type'],
            status: params['status'],
            configJson: this.selected,
            remark: params['remark']
          };
          break;
        }
        case '34': {
          return {
            type: params['type'],
            status: params['status'],
            remark: params['remark']
          };
          break;
        }
        case '35': {
          return {
            type: params['type'],
            status: params['status'],
            remark: params['remark']
          };
          break;
        }
        case '55': {
          return {
            type: params['type'],
            status: params['status'],
            remark: params['remark']
          };
          break;
        }
        case '56': {
          return {
            type: params['type'],
            status: params['status'],
            remark: params['remark']
          };
          break;
        }
        case '57': {
          return {
            type: params['type'],
            status: params['status'],
            remark: params['remark']
          };
          break;
        }
        case '58': {
          return {
            type: params['type'],
            status: params['status'],
            remark: params['remark']
          };
          break;
        }
        case '59': {
          return {
            type: params['type'],
            status: params['status'],
            remark: params['remark']
          };
          break;
        }
        case '60': {
          return {
            type: params['type'],
            status: params['status'],
            equipmentIds: [params['equipmentIds']],
            remark: params['remark']
          };
          break;
        }
        case '61': {
          return {
            type: params['type'],
            status: params['status'],
            remark: params['remark']
          };
          break;
        }
        case '62': {
          let validateItem = { validateItem: this.configJson.validateItem };
          return {
            type: params['type'],
            status: params['status'],
            configJson: validateItem,
            remark: params['remark']
          };
          break;
        }
        case '63': {
          return {
            type: params['type'],
            status: params['status'],
            remark: params['remark'],
            configJson: this.configJson
          };
          break;
        }
        case '64': {
          return {
            type: params['type'],
            status: params['status'],
            remark: params['remark']
          };
          break;
        }
        case '65': {
          return {
            type: params['type'],
            status: params['status'],
            remark: params['remark']
          };
          break;
        }
        case '66': {
          return {
            type: params['type'],
            status: params['status'],
            configJson: this.configJson,
            remark: params['remark']
          };
          break;
        }
        case '67': {
          return {
            type: params['type'],
            status: params['status'],
            configJson: this.configJson,
            remark: params['remark']
          };
          break;
        }
        case '68': {
          return {
            type: params['type'],
            status: params['status'],
            configJson: this.configJson,
            remark: params['remark']
          };
          break;
        }
        case '69': {
          return {
            type: params['type'],
            status: params['status'],
            configJson: this.configJson,
            remark: params['remark']
          };
          break;
        }
        case '70': {
          return {
            type: params['type'],
            status: params['status'],
            configJson: this.configJson,
            remark: params['remark']
          };
          break;
        }
        case '71': {
          return {
            type: params['type'],
            status: params['status'],
            configJson: this.configJson,
            remark: params['remark']
          };
          break;
        }
        case '73': {
          return {
            type: params['type'],
            status: params['status'],
            remark: params['remark']
          };
          break;
        }
        case '72': {
          if (!this.configJson.limitHour) {
            this.$message.error(this.$t('xianzhishichangbitian'));
            return null;
          }
          return {
            type: params['type'],
            status: params['status'],
            remark: params['remark'],
            configJson: this.configJson
          };
          break;
        }
        case '74': {
          return {
            type: params['type'],
            status: params['status'],
            remark: params['remark']
          };
          break;
        }
        case '75': {
          const status = params['status'];
          let configJson = {};
          if (status === 1) {
            configJson = this.configJson;
            // 校验 configJson 中的必填字段
            const requiredFields = [
              { field: 'broadcastUrl', message: this.$t('guangbojiekoudizhi') },
              { field: 'loopCount', message: this.$t('xunhuanchici') },
              { field: 'loopInterval', message: this.$t('xunhuanjiangezhongji(miao)') },
              { field: 'maxPlayTime', message: this.$t('bopiaozuichangshijian(miao)') },
              { field: 'exceptionBroadcastContent', message: this.$t('chufaichangguangboneirong') },
              { field: 'confirmTimeoutBroadcastContent', message: this.$t('andengquerenchaozhiaguangbo') },
              { field: 'secretKey', message: this.$t('jiekoukey') },
              { field: 'deviceCodes', message: this.$t('yinxiangshebeibianma') },
              { field: 'processTimeoutBroadcastContent', message: this.$t('andengchulichaozhiaguangbo') }
            ];

            const missingFields = requiredFields.filter(({ field }) => !this.configJson[field]);

            if (missingFields.length > 0) {
              const missingMessages = missingFields.map(({ message }) => message).join('、');
              this.$message({
                message: missingMessages + this.$t('bitian'),
                type: 'error',
                duration: 5 * 1000
              });
              return null;
            }

          }
          return {
            type: params['type'],
            status: params['status'],
            remark: params['remark'],
            configJson: configJson
          };
          break;
        }
        case '76': {
          const status = params['status'];
          let configJson = {};
          if (status === 1) {
            configJson = this.configJson;
            // 校验 configJson 中的必填字段
            const requiredFields = [
              { field: 'broadcastUrl', message: this.$t('guangbojiekoudizhi') },
              { field: 'loopCount', message: this.$t('xunhuanchici') },
              { field: 'loopInterval', message: this.$t('xunhuanjiangezhongji(miao)') },
              { field: 'maxPlayTime', message: this.$t('bopiaozuichangshijian(miao)') },
              { field: 'andonStatus', message: this.$t('andengzhuangtai') },
              { field: 'broadcastContent', message: this.$t('chufaichangguangboneirong') },
              { field: 'secretKey', message: this.$t('jiekoukey') },
              { field: 'deviceCodes', message: this.$t('yinxiangshebeibianma') }
            ];
            // 如果选择了指定时间播放，还需验证 timeList
            if (configJson.broadcastTime === '2') {
              requiredFields.push({ field: 'timeList', message: this.$t('guangboshijian') });
            }

            let missingFields = requiredFields.filter(({ field }) =>  {
              let value = this.configJson[field];
              // 对于 andonStatus，允许 0 作为有效值，但不允许 null、undefined
              if (field === 'andonStatus') {
                return value === null || value === undefined;
              }
              // 其他字段的检查
              return !value;
            });
            if (missingFields.length > 0) {
              let missingMessages = missingFields.map(({ message }) => message).join('、');
              this.$message({
                message: missingMessages + this.$t('bitian'),
                type: 'error',
                duration: 5 * 1000
              });
              return null;
            }
            if (configJson.timeList && Array.isArray(configJson.timeList)) {
              let timeRegex = /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/;
              configJson.timeList = configJson.timeList.filter(timeStr =>
                  typeof timeStr === 'string' && timeRegex.test(timeStr)
              );
            }
          }
          return {
            type: params['type'],
            status: params['status'],
            remark: params['remark'],
            configJson: configJson
          };
          break;
        }
        case '77': {
          return {
            type: params['type'],
            status: params['status'],
            remark: params['remark']
          };
          break;
        }
        case '78': {
          if (params['status'] === 1) {
            if (this.configJson.limitHour == null || this.configJson.limitHour < 1) {
              this.$message.error(this.$t('xianzhishichangbitian'));
              return null;
            }
          }
          return {
            type: params['type'],
            status: params['status'],
            remark: params['remark'],
            configJson: this.configJson
          };
          break;
        }
      }
    },
    beforeEditReq(params) {
      switch (params['type']) {
        case '31': {
          const status = params['status'];
          let configJson = {};
          if (status === 1) {
            configJson = this.configJson;
          }
          return {
            id: params['id'],
            type: params['type'],
            status: params['status'],
            remark: params['remark'],
            configJson: configJson
          };
          break;
        }
        case '33': {
          return {
            id: params['id'],
            type: params['type'],
            status: params['status'],
            configJson: this.selected,
            remark: params['remark']
          };
          break;
        }
        case '7': {
          return {
            id: params['id'],
            type: params['type'],
            status: params['status'],
            configJson: this.configJson,
            remark: params['remark']
          };
        }
        case '60': {
          return {
            id: params['id'],
            type: params['type'],
            status: params['status'],
            equipmentIds: [params['equipmentIds']],
            remark: params['remark']
          };
          break;
        }
        case '62': {
          let validateItem = { validateItem: this.configJson.validateItem };
          return {
            id: params['id'],
            type: params['type'],
            status: params['status'],
            configJson: validateItem,
            remark: params['remark']
          };
          break;
        }

        case '66': {
          return {
            id: params['id'],
            type: params['type'],
            status: params['status'],
            configJson: this.configJson,
            remark: params['remark']
          };
          break;
        }
        case '72': {
          if (!this.configJson.limitHour) {
            this.$message.error(this.$t('xianzhishichangbitian'));
            return null;
          }
          return {
            id: params['id'],
            type: params['type'],
            status: params['status'],
            remark: params['remark'],
            configJson: this.configJson
          };
          break;
        }
        case '75': {
          const status = params['status'];
          let configJson = {};
          if (status === 1) {
            configJson = this.configJson;
            // 校验 configJson 中的必填字段
            const requiredFields = [
              { field: 'broadcastUrl', message: this.$t('guangbojiekoudizhi') },
              { field: 'loopCount', message: this.$t('xunhuanchici') },
              { field: 'loopInterval', message: this.$t('xunhuanjiangezhongji(miao)') },
              { field: 'maxPlayTime', message: this.$t('bopiaozuichangshijian(miao)') },
              { field: 'exceptionBroadcastContent', message: this.$t('chufaichangguangboneirong') },
              { field: 'confirmTimeoutBroadcastContent', message: this.$t('andengquerenchaozhiaguangbo') },
              { field: 'secretKey', message: this.$t('jiekoukey') },
              { field: 'deviceCodes', message: this.$t('yinxiangshebeibianma') },
              { field: 'processTimeoutBroadcastContent', message: this.$t('andengchulichaozhiaguangbo') }
            ];

            const missingFields = requiredFields.filter(({ field }) => !this.configJson[field]);

            if (missingFields.length > 0) {
              const missingMessages = missingFields.map(({ message }) => message).join('、');
              this.$message({
                message: missingMessages + this.$t('bitian'),
                type: 'error',
                duration: 5 * 1000
              });
              return null;
            }

          }
          return {
            id: params['id'],
            type: params['type'],
            status: params['status'],
            remark: params['remark'],
            configJson: this.configJson
          };
          break;
        }
        case '76': {
          const status = params['status'];
          let configJson = {};
          if (status === 1) {
            configJson = this.configJson;
            // 校验 configJson 中的必填字段
            const requiredFields = [
              { field: 'broadcastUrl', message: this.$t('guangbojiekoudizhi') },
              { field: 'loopCount', message: this.$t('xunhuanchici') },
              { field: 'loopInterval', message: this.$t('xunhuanjiangezhongji(miao)') },
              { field: 'maxPlayTime', message: this.$t('bopiaozuichangshijian(miao)') },
              { field: 'andonStatus', message: this.$t('andengzhuangtai') },
              { field: 'broadcastContent', message: this.$t('chufaichangguangboneirong') },
              { field: 'secretKey', message: this.$t('jiekoukey') },
              { field: 'deviceCodes', message: this.$t('yinxiangshebeibianma') }
            ];
            // 如果选择了指定时间播放，还需验证 timeList
            if (configJson.broadcastTime === '2') {
              requiredFields.push({ field: 'timeList', message: this.$t('guangboshijian') });
            }

            let missingFields = requiredFields.filter(({ field }) =>  {
              let value = this.configJson[field];
              // 对于 andonStatus，允许 0 作为有效值，但不允许 null、undefined
              if (field === 'andonStatus') {
                return value === null || value === undefined;
              }
              // 其他字段的检查
              return !value;
            });

            if (missingFields.length > 0) {
              let missingMessages = missingFields.map(({ message }) => message).join('、');
              this.$message({
                message: missingMessages + this.$t('bitian'),
                type: 'error',
                duration: 5 * 1000
              });
              return null;
            }
            if (configJson.timeList && Array.isArray(configJson.timeList)) {
              let timeRegex = /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/;
              configJson.timeList = configJson.timeList.filter(timeStr =>
                  typeof timeStr === 'string' && timeRegex.test(timeStr)
              );
            }
          }
          return {
            id: params['id'],
            type: params['type'],
            status: params['status'],
            remark: params['remark'],
            configJson: configJson
          };
          break;
        }
        case '77': {
          return {
            id: params['id'],
            type: params['type'],
            status: params['status'],
            remark: params['remark']
          };
          break;
        }
        case '78': {
          if (params['status'] === 1) {
            if (this.configJson.limitHour == null || this.configJson.limitHour < 1) {
              this.$message.error(this.$t('xianzhishichangbitian'));
              return null;
            }
          }
          return {
            id: params['id'],
            type: params['type'],
            status: params['status'],
            remark: params['remark'],
            configJson: this.configJson
          };
          break;
        }
      }
      return params;
    },
    beforeShowEditDialog(editObj) {
      if (editObj.action === 'xinzeng') {
        editObj.type = '0';
        editObj.status = 1;
        editObj.autoCreateMouldAdapterEquipmentData = 0;
        editObj.productionConfigDetailsList = [
          {
            roleId: '',
            reportingInterval: '',
            effect: ''
          }
        ];
      }
      if (editObj.action === 'bianji') {
        this.configJson = editObj.configJson;
        if (editObj.type === '33') {
          this.initAppWoExecutionConfig(editObj);
        } else if (editObj.type === '60') {
          editObj.equipmentIds = parseInt(editObj.equipmentIds[0]);
        } else if (editObj.type === '7') {
          if (this.configJson == null) {
            this.configJson = {};
          }
        } else if (editObj.type === '78') {
          if (this.configJson == null || typeof this.configJson !== 'object') {
            this.configJson = {};
          }
          if (this.configJson.limitHour == null || this.configJson.limitHour < 1) {
            this.$set(this.configJson, 'limitHour', 1);
          }
        } else if (editObj.type === '76') {
          if (this.configJson.timeList && Array.isArray(this.configJson.timeList)) {
            let timeRegex = /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/;
            this.configJson.timeList = this.configJson.timeList.filter(timeStr =>
                typeof timeStr === 'string' && timeRegex.test(timeStr)
            );
          } else {
            this.configJson.timeList = [];
          }
        }
      }
      return editObj;
    },
    addItem() {
      console.log('this.yt.editObj.productionConfigDetailsList', this.yt.editObj.productionConfigDetailsList);

      this.yt.editObj.productionConfigDetailsList.push({
        roleId: '',
        reportingInterval: '',
        effect: ''
      });
    },
    deleteItem(key) {
      this.yt.editObj.productionConfigDetailsList = this.yt.editObj.productionConfigDetailsList.filter((item, index) => {
        return index !== key;
      });
    },
    dictionaryChange(val) {
      if (val === '6' || val === '8' || val === '9' || val === '10') {
        this.yt.editObj.status = 1;
      }
      if (val === '33') {
        this.initAppWoExecutionConfig(this.yt.editObj);
      }
      if (val === '31') {
        this.$set(this.configJson, 'protocol', 'http://');
      } else if (val === '75') {
          this.configJson = {
            broadcastUrl: '', // 广播接口地址
            loopCount: 1, // 循环次数，默认值
            loopInterval: 3, // 循环间隔时间，默认值
            maxPlayTime: 60, // 播放最长时间，默认值
            exceptionBroadcastContent: '设备名称{设备名称}，安灯描述{异常描述}，请及时处理', // 触发异常广播内容
            confirmTimeoutBroadcastContent: '确认安灯超时，设备名称{设备名称}，安灯描述{异常描述}，请及时处理', // 安灯确认超时广播内容
            processTimeoutBroadcastContent: '处理安灯超时，设备名称{设备名称}，安灯描述{异常描述}，请及时处理', // 安灯处理超时广播内容
            secretKey: '', // 密钥
            deviceCodes: '' // 设备编号
          }
      } else if (val === '76') {
        this.configJson = {
          broadcastUrl: '', // 广播接口地址
          loopCount: 1, // 循环次数，默认值
          loopInterval: 3, // 循环间隔时间，默认值
          maxPlayTime: 60, // 播放最长时间，默认值
          broadcastContent: '设备名称{设备名称}，安灯描述{异常描述}，请及时处理', // 触发异常广播内容
          andonStatus: 0,//安灯状态，默认待确认
          secretKey: '', // 密钥
          deviceCodes: '', // 设备编号
          broadcastTime: '1', // 默认选择一直循环播放
          timeList: [] // 初始化为空数组
        }
      } else if (val === '78') {
        this.configJson = { limitHour: 1 };
      } else if (val === '79') {
        this.$set(this.yt.editObj, 'mouldStatus', ['0']);
        this.$set(this.yt.editObj, 'status', 1);
        this.configJson = null;
      } else {
        this.configJson = null;
      }
    },
    initAppWoExecutionConfig(editObj) {
      this.generateTransferColumns = [];
      this.generateTransferColumns = ['shengchangongdanhao', 'chanpinbianma', 'chanpinmingcheng', 'mujubianhao', 'wangongyuceshijian', 'jihuashuliang', 'yibaogongliangpinshu', 'yanse', 'caizhi', 'guige', 'erpwuliaobianma', 'progress'];
      this.generateTransferColumns = this.generateTransferColumns.map(item => {
        return { label: this.$t(item), key: item };
      });
      this.detailColumns = [];
      this.detailColumns = ['jihuashuliang', 'baogongshuliang', 'yibaogongliangpinshu', 'yibaogongbuliangpinshu', 'shengyushengchanshuliang', 'guige', 'beizhu', 'shijimoqiangshu', 'biaozhun/shijizhouqi(s)', 'shebeimingcheng', 'mujubianhao', 'dangqianliaohao', 'chanpinbianma', 'chanpinmingcheng', 'wuliaomiaoshu', 'chuangjianshijian', 'jihuakaishishijian', 'jihuawanchengshijian', 'shijikaishishijian', 'shijiwanchengshijian','caizhi','yanse','sefen'];
      this.detailColumns = this.detailColumns.map(item => {
        return { label: this.$t(item), key: item };
      });
      if (editObj.configJson != undefined && editObj.configJson != null) {
        this.selected = editObj.configJson;
        // 判断数组元素类型并处理
        if (this.selected.list && this.selected.list.length > 0) {
          if (typeof this.selected.list[0] === 'object' && this.selected.list[0].key) {
            // 元素是包含key的对象
            this.showColumns = this.selected.list.map(item => item.key);
          } else if (typeof this.selected.list[0] === 'string') {
            // 元素是字符串
            this.showColumns = this.selected.list;
          }
        }

        // 对detail做同样处理
        if (this.selected.detail && this.selected.detail.length > 0) {
          if (typeof this.selected.detail[0] === 'object' && this.selected.detail[0].key) {
            this.detailShowColumns = this.selected.detail.map(item => item.key);
          } else if (typeof this.selected.detail[0] === 'string') {
            this.detailShowColumns = this.selected.detail;
          }
        }
      } else {
        this.showColumns = this.generateTransferColumns.map(item => {
          return item.key;
        });
        this.detailShowColumns = this.detailColumns.map(item => {
          return item.key;
        });
      }
      this.showColumnsChange();
      this.detailShowColumnsChange();
    },
    showColumnsChange() {
      //保存
      //this.$set(this.selected, 'list', this.generateTransferColumns.filter(item => this.showColumns.indexOf(item.key) > -1).map(item => item.key));
      const orderedList = this.showColumns.filter(key =>
        this.generateTransferColumns.some(item => item.key === key)
      );
      this.$set(this.selected, 'list', orderedList);
    },
    detailShowColumnsChange() {
      //保存
      // this.$set(this.selected, 'detail', this.detailColumns.filter(item => this.detailShowColumns.indexOf(item.key) > -1).map(item => item.key));
      const orderedList = this.detailShowColumns.filter(key =>
        this.detailColumns.some(item => item.key === key)
      );
      this.$set(this.selected, 'detail', orderedList);
    },


    // 显示用户个性化配置弹窗
    showUserPersonalConfigDialog() {
      this.isShowUserPersonalConfigDialog = true;
      this.$nextTick(() => {
        this.initUserPersonalConfig();
      });
    },
    // 初始化用户个性化配置
    initUserPersonalConfig() {
      // 初始化工单执行列
      this.userPersonalGenerateTransferColumns = [];
      this.userPersonalGenerateTransferColumns = ['shengchangongdanhao', 'chanpinbianma', 'chanpinmingcheng', 'mujubianhao', 'wangongyuceshijian', 'jihuashuliang', 'yibaogongliangpinshu', 'yanse', 'caizhi', 'guige', 'erpwuliaobianma', 'progress'];
      this.userPersonalGenerateTransferColumns = this.userPersonalGenerateTransferColumns.map(item => {
        return { label: item, key: item };
      });
      // 初始化工单详情列
      this.userPersonalDetailColumns = [];
      this.userPersonalDetailColumns = ['jihuashuliang', 'baogongshuliang', 'yibaogongliangpinshu', 'yibaogongbuliangpinshu', 'shengyushengchanshuliang', 'guige', 'beizhu', 'shijimoqiangshu', 'biaozhun/shijizhouqi(s)', 'shebeimingcheng', 'mujubianhao', 'dangqianliaohao', 'chanpinbianma', 'chanpinmingcheng', 'wuliaomiaoshu', 'chuangjianshijian', 'jihuakaishishijian', 'jihuawanchengshijian', 'shijikaishishijian', 'shijiwanchengshijian','caizhi','yanse','sefen'];
      this.userPersonalDetailColumns = this.userPersonalDetailColumns.map(item => {
        return { label: item, key: item };
      });

      this.userPersonalShowColumns = [];
      this.userPersonalDetailShowColumns = [];
      // 从接口获取用户个性化配置
      const params = {
        productionConfigId: this.yt.editObj.id,
        userId: this.store.state.user ? this.store.state.user.id : null,
        customerId: this.store.state.customer ? this.store.state.customer.id : null
      };
      // 修改 initUserPersonalConfig 方法中的接口处理逻辑
      this.http.get('/web/production/config/user/setting/list', { params: params })
        .then(result => {
          if (result && result.data && result.data.length > 0) {
            // 保存配置记录的 id
            this.userPersonalConfigId = result.data[0].id;
            const config = result.data[0].configJson;
            this.userPersonalSelected = config;

            if (config.list && config.list.length > 0) {
              if (typeof config.list[0] === 'object' && config.list[0].key) {
                this.userPersonalShowColumns = config.list.map(item => item.key);
              } else if (typeof config.list[0] === 'string') {
                this.userPersonalShowColumns = config.list;
              }
            }

            if (config.detail && config.detail.length > 0) {
              if (typeof config.detail[0] === 'object' && config.detail[0].key) {
                this.userPersonalDetailShowColumns = config.detail.map(item => item.key);
              } else if (typeof config.detail[0] === 'string') {
                this.userPersonalDetailShowColumns = config.detail;
              }
            }
          } else {
            // 没有配置时清空 ID
            this.userPersonalConfigId = null;
            // 如果没有保存的配置,使用默认值(全部显示)
            this.userPersonalShowColumns = this.userPersonalGenerateTransferColumns.map(item => item.key);
            this.userPersonalDetailShowColumns = this.userPersonalDetailColumns.map(item => item.key);
          }

          this.userPersonalShowColumnsChange();
          this.userPersonalDetailShowColumnsChange();
        })

    },
    // 用户个性化配置 - 工单执行列变化
    userPersonalShowColumnsChange() {
      //this.$set(this.userPersonalSelected, 'list', this.userPersonalGenerateTransferColumns.filter(item => this.userPersonalShowColumns.indexOf(item.key) > -1).map(item => item.key));
      const orderedList = this.userPersonalShowColumns.filter(key =>
        this.userPersonalGenerateTransferColumns.some(item => item.key === key)
      );
      this.$set(this.userPersonalSelected, 'list', orderedList);
    },
    // 用户个性化配置 - 工单详情列变化
    userPersonalDetailShowColumnsChange() {
      //this.$set(this.userPersonalSelected, 'detail', this.userPersonalDetailColumns.filter(item => this.userPersonalDetailShowColumns.indexOf(item.key) > -1).map(item => item.key));
      const orderedList = this.userPersonalDetailShowColumns.filter(key =>
        this.userPersonalDetailColumns.some(item => item.key === key)
      );
      this.$set(this.userPersonalSelected, 'detail', orderedList);
    },
    // 保存用户个性化配置
    saveUserPersonalConfig() {
      const params = {
        configJson: this.userPersonalSelected,
        productionConfigId: this.yt.editObj.id,
        userId: this.store.state.user ? this.store.state.user.id : null,
        customerId: this.store.state.customer ? this.store.state.customer.id : null
      };

      // 如果存在配置记录 ID，则添加到参数中
      if (this.userPersonalConfigId) {
        params.id = this.userPersonalConfigId;
      }
      this.http.post('/web/production/config/user/setting/createOrUpdate', params)
        .then(result => {
          this.utils.successMessage(this.$t(result.msg));
          this.isShowUserPersonalConfigDialog = false;
        })
        .catch(error => {
          this.utils.errorMessage(error);
        });
    },

    // 用户个性化配置 - 工单详情列排序
    changeCommonColumns(type, value, changeColumns) {
      let valueIndex = null;
      for (let i = 0; i < changeColumns.length; i++) {
        if (changeColumns[i] === value) {
          valueIndex = i;
        }
      }
      if (type === 'up' && valueIndex !== 0) {
        const beforeValue = changeColumns[valueIndex - 1]; // 上一个值
        changeColumns.splice(valueIndex, 1, beforeValue);
        changeColumns.splice(valueIndex - 1, 1, value);
      }
      if (type === 'down' && valueIndex !== changeColumns.length - 1) {
        const afterValue = changeColumns[valueIndex + 1]; // 下一个值
        changeColumns.splice(valueIndex, 1, afterValue);
        changeColumns.splice(valueIndex + 1, 1, value);
      }

      // 判断changeColumns属于哪个column，然后触发相应的变更方法
      if (changeColumns === this.userPersonalShowColumns) {
        this.userPersonalShowColumnsChange();
      } else if (changeColumns === this.userPersonalDetailShowColumns) {
        this.userPersonalDetailShowColumnsChange();
      } else if (changeColumns === this.showColumns) {
        this.showColumnsChange();
      } else if (changeColumns === this.detailShowColumns) {
        this.detailShowColumnsChange();
      }
    },
    generateTimeOptions() {
      this.timeOptions = [];
      for (let hour = 0; hour <= 23; hour++) {
        const timeString = `${hour}:00`;
        this.timeOptions.push({
          value: timeString,
          label: timeString
        });
      }
    },
    // 输入时验证
    filterTimeOptions(value) {
      console.log(value)
      if (Array.isArray(value)){
        let timeRegex = /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/;
        let validValues = [];
        value.forEach(v => {
          if (!timeRegex.test(v)) {
            this.$message.error("时间格式不正确，请使用 HH:MM 格式");
          }else {
            validValues.push(v);
          }
        });
        // 确保模型值只包含有效的时间
        if (validValues.length !== value.length) {
          this.configJson.timeList = validValues;
        }
      }
    },
  },
  computed: {
    currentUserName() {
      return this.store && this.store.state && this.store.state.user ? this.store.state.user.nickname : '';
    }
  }
};
</script>
